import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: "dtm-map-global-spatial-info-settings",
    templateUrl: "./global-spatial-info-settings.component.html",
    styleUrls: ["../geographical-zones-common.scss", "./global-spatial-info-settings.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalSpatialInfoSettingsComponent {}
